import {$} from '../jquery-definition.js';
import jQueryBridget from 'jquery-bridget';
import Flickity from 'flickity';
import 'flickity-bg-lazyload';
import 'flickity-imagesloaded';
import 'flickity-sync';
import '@fancyapps/fancybox';

// make Flickity a jQuery plugin
Flickity.setJQuery( $ );
jQueryBridget( 'flickity', Flickity, $ );

$( '.image-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.2,
		friction: 0.8,
		cellAlign: 'left',
		contain: true,
		imagesLoaded: true,
		wrapAround: true,
		resize: true,
	} );

	var flkty = $carousel.data( 'flickity' );
	var selectedIndex = flkty.selectedIndex;
	var slideCount = flkty.slides.length;

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );

	$carousel.on( 'click', function( event, pointer, cellElement, cellIndex ) {
		// Do nothing if cell was not clicked
		if ( !cellElement ) {
			return;
		}

		// Find image url and use it to tell Fancybox what to target
		var $zoomurl = $( cellElement ).attr( 'data-image-src' );
		$.fancybox( $zoomurl, {
			buttons: ["zoom"],
		} );
	} );
} );

$( '.map-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.2,
		friction: 0.8,
		cellAlign: 'left',
		contain: true,
		imagesLoaded: true,
		resize: true,
		draggable: false,
	} );

	var flkty = $carousel.data( 'flickity' );

	var $carouselContainer = $this.parents( '.carousel-container' );

	$carouselContainer.find( '.carousel-nav-link-container a' ).on( 'click', function( clickEvent ) {
		var $this = $( this );
		var $parent = $this.parents( '.carousel-nav-link-container' );

		var index = $parent.index();

		$carouselContainer.find( '.carousel-nav-link-container a' ).removeClass( '!bg-beige' ).find( 'svg' ).addClass( 'lg:hidden' );
		$this.addClass( '!bg-beige' ).find( 'svg' ).removeClass( 'lg:hidden' ).toggleClass( '!-rotate-90' );

		$carousel.flickity( 'selectCell', index );

		$( '.map-description' ).removeClass( 'lg:block' ).addClass( 'lg:hidden' ).eq( index ).removeClass( 'lg:hidden' ).addClass( 'lg:block' );

		$( '.mobile-map-description' ).not( ':eq(' + index + ')' ).addClass( 'hidden' );
		$( '.mobile-map-description' ).eq( index ).toggleClass( 'hidden' );
	} );
} );

$( '.content-image-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.2,
		friction: 0.8,
		cellAlign: 'left',
		contain: true,
		imagesLoaded: true,
		bgLazyLoad: 2,
		wrapAround: true,
		resize: true,
		setGallerySize: false,
	} );

	var flkty = $carousel.data( 'flickity' );

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );
} );

$( '.content-text-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		pageDots: false,
		prevNextButtons: false,
		selectedAttraction: 0.2,
		friction: 0.8,
		cellAlign: 'left',
		contain: true,
		imagesLoaded: true,
		wrapAround: true,
		adaptiveHeight: true,
		resize: true,
		sync: $this.attr( 'data-nav-for' ),
	} ).on( 'change.flickity', function( event, index ) {
		$carousel.flickity( 'resize' );
	} );
} );

$( '.floorplan-carousel' ).each( function() {
	var $this = $( this );

	var $carousel = $this.flickity( {
		bgLazyLoad: 2,
		pageDots: false,
		prevNextButtons: false,
		contain: true,
		wrapAround: false,
		resize: true,
		adaptiveHeight: true,
	} );

	var $previous = $this.parents( '.carousel-container' ).find( '.carousel-previous' );
	var $next = $this.parents( '.carousel-container' ).find( '.carousel-next' );

	$previous.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'previous' );
	} );

	$next.on( 'click', function( clickEvent ) {
		$carousel.flickity( 'next' );
	} );
} );
